import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {LoginService} from '@services/login/login.service';
import {catchError, switchMap} from 'rxjs/operators';
import {throwError} from 'rxjs';

export const tokenInterceptor: HttpInterceptorFn = (request, next) => {
  const login = inject(LoginService);
  const token = login.getToken();
  const req = request.clone({withCredentials: true, setHeaders: token ? {Authorization: `Bearer ${token}`} : {}});
  return next(req).pipe(catchError(error => {
    const authCall = request.url.includes('/v1/staff/auth/');
    if (error.status === 401 && !authCall && !request.headers.has('X-Auth-Retry')) {
      return login.refreshSession().pipe(switchMap(ok => ok
        ? next(request.clone({withCredentials: true, setHeaders: {Authorization: `Bearer ${login.getToken()}`, 'X-Auth-Retry': '1'}}))
        : throwError(() => error)));
    }
    return throwError(() => error);
  }));
};
